<template>
	<div class="Authority">
		<div class="TopSearch">
			<FromComm :FromArr="FromArr"></FromComm>
			<CommonBtngroup ref="btngroup" style="margin-top: -35px;" :qhide="false" :chackbox="true" checktitle="待我审批"
				@select="select" @reset="reset" />
		</div>
		<div class="BottomTable">
			<div style="display: inline-block;">
				<Commonbtn v-if="qx.add" backgroundColor="#FFF" title="新增" fontSize="14px" @btnclick="add"
					:src="require('@/assets/icon/icon-add.png')">
				</Commonbtn>
			</div>
			<div style="display: inline-block;">
				<Commonbtn v-if="qx.add" backgroundColor="#FFF" title="变更" fontSize="14px" @btnclick="update('change')"
					:useAutoOptional="false" :optional="DataListOK.length !== 1"
					:src="require('@/assets/icon/icon-add.png')">
				</Commonbtn>
			</div>
			<div style="display: inline-block;">
				<Commonbtn v-if="qx.update" backgroundColor="#FFF" title="修改" fontSize="14px" @btnclick="update('edit')"
					:useAutoOptional="false" :optional="DataListOK.length !== 1"
					:src="require('@/assets/icon/icon-update.png')">
				</Commonbtn>
			</div>
			<div style="display: inline-block;">
				<Commonbtn backgroundColor="#FFF" :src="require('@/assets/icon/look.png')" title="查看" fontSize="14px"
					@btnclick="update('look')" :useAutoOptional="false" :optional="DataListOK.length !== 1">
				</Commonbtn>
			</div>

			<div style="display: inline-block;">
				<Commonbtn v-if="qx.del" backgroundColor="#FFF" title="删除" fontSize="14px" @btnclick="del"
					:useAutoOptional="false" :optional="DataListOK.length === 0"
					:src="require('@/assets/icon/icon-del.png')">
				</Commonbtn>
			</div>
			<div style="display: inline-block;">
				<Commonbtn backgroundColor="#FFF" title="导出" fontSize="14px" @btnclick="AppExport"
					:src="require('@/assets/icon/daoc.png')">
				</Commonbtn>
			</div>
			<div style="display: inline-block;">
				<Commonbtn backgroundColor="#FFF" v-if="qx.submit" title="提交" fontSize="14px" @btnclick="SubmitApply"
					:useAutoOptional="false" :optional="DataListOK.length === 0"
					:src="require('@/assets/channel/Submit.png')">
				</Commonbtn>
			</div>
			<div style="display: inline-block;">
				<Commonbtn backgroundColor="#FFF" title="撤回" v-if="qx.submit" fontSize="14px" @btnclick="Withdraw"
					:useAutoOptional="false" :optional="DataListOK.length === 0"
					:src="require('@/assets/channel/withdraw.png')">
				</Commonbtn>
			</div>
			<div style="display: inline-block;">
				<Commonbtn v-if="qx.setting" backgroundColor="#FFF" title="渠道备注" fontSize="14px"
					:useAutoOptional="false" :optional="DataListOK.length === 0"
					@btnclick="ChannelRemark" :src="require('@/assets/icon/icon-update.png')">
				</Commonbtn>
			</div>
			<div style="display: inline-block;">
				<Commonbtn backgroundColor="#FFF" v-if="qx.approval" title="审批通过" fontSize="14px" @btnclick="Approved"
					:useAutoOptional="false" :optional="DataListOK.length === 0"
					:src="require('@/assets/channel/Approved.png')">
				</Commonbtn>
			</div>
			<div style="display: inline-block;">
				<Commonbtn backgroundColor="#FFF" v-if="qx.approval" title="审批驳回" fontSize="14px"
					:useAutoOptional="false" :optional="DataListOK.length === 0"
					@btnclick="Rejectapproval()" :src="require('@/assets/channel/Rejectapproval.png')">
				</Commonbtn>
			</div>
			<div style="display: inline-block;">
				<Commonbtn v-if="qx.enabled" backgroundColor="#FFF" title="启用配送" fontSize="14px"
					:useAutoOptional="false" :optional="DataListOK.length === 0"
					@btnclick="Enabledapproval" :src="require('@/assets/icon/icon-enabled.png')">
				</Commonbtn>
			</div>
			<div style="display: inline-block;">
				<Commonbtn v-if="qx.enabled" backgroundColor="#FFF" title="驳回配送" fontSize="14px"
					:useAutoOptional="false" :optional="DataListOK.length === 0"
					@btnclick="Rejectapproval('Dispatch')" :src="require('@/assets/channel/Rejectapproval.png')">
				</Commonbtn>
			</div>
			<div style="display: inline-block;">
				<Commonbtn backgroundColor="#FFF" title="审批流程" fontSize="14px" @btnclick="Approvalprocess"
					:useAutoOptional="false" :optional="DataListOK.length !== 1"
					:src="require('@/assets/channel/Approvalprocess.png')">
				</Commonbtn>
			</div>
			<div style="display: inline-block;">
				<CommonbtnUpLoad v-if="qx.add" style="display: inline-block;margin-top: 10px;" backgroundColor="#FFF"
					title="导入" fontSize="14px" @getFile="seImport" types="file"
					:src="require('@/assets/icon/icon-drjys.png')">
				</CommonbtnUpLoad>
			</div>
			<a class="Dowload" @click="SeconDowload">导入模版下载</a>

			<div class="Table">
				<Commontable ref="refTableCenter" @handleSelectionChange="(e)=>DataListOK = e" @onRowClick="onRowClick"
					width="1000px" colnum=5 color :hasChecked="false" :tableData="tableData" :headerData="headerData"
					height="100%">
				</Commontable>
				<div class="pagination">
					<Pagination ref="invPagination" type='allColor' :pageSize="pageSize"
						@handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange" :total="total">
					</Pagination>
				</div>
			</div>
		</div>
		<DialogFrom :width="fileList.length?'800px':'450px'" :title="TitleEditor"
			:OKASCAN="TitleEditor === '查看配送申请'?false:true" :dialogVisible="dialogVisibAuthorizationsAdd"
			@cancel="cancelAuthorizationsAdd" @dialogOK="dialogOKAuthorizationsAdd">
			<div class="dialog-view" style="display:flex;">
				<div class="view-form">
					<FromComm :FromArr="FromArrEditor" @remoteMethod="remoteMethod"
						@selectChange="handleEditorSelectChange"></FromComm>
					<CommonbtnUpLoad v-if="TitleEditor === '查看配送申请'?false:true"
						style="transform: translate(97px, 14px);" backgroundColor="#FFF" types="UploadAll" title="文件上传"
						fontSize="14px" @getFile="UploadFiles" :src="require('@/assets/icon/daoc.png')">
					</CommonbtnUpLoad>
				</div>
				<div class="view-upload" v-if="fileList.length">
					<div class="UploadData">
						<div class="lable">
							文件列表：
						</div>
						<div class="imgOrFile">
							<div class="file" v-for="(item,index) in fileList" :key="index">
								<span class="fileName">
									{{ item.FileNameOrg?item.FileNameOrg:item.FileName}}
								</span>
								<span class="Del" v-if="TitleEditor === '查看配送申请'?false:true"
									@click="handDelFile(index)">删除</span>
								<span class="See" @click="handViewFile(item)">查看</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</DialogFrom>

		<DialogFrom width="890px" :title="title" :dialogVisible="dialogVisiblesdrjg" @cancel="canceldrjg"
			@dialogOK="dialogOKdrjg">
			<div class="from">
				<Commontable @onRowClick="onRowClick" width="830px" colnum=100 :tableData="tableDatadrjg" height="100%">
				</Commontable>
			</div>
		</DialogFrom>
		<DialogFrom width="890px" title="驳回原因" :dialogVisible="dialogVisibleReject" @cancel="cancelReject"
			@dialogOK="dialogOKReject">
			<div style="margin-left: -20px;">
				<el-input type="textarea" :rows="2" placeholder="请输入驳回原因" v-model="RejectText">
				</el-input>
			</div>
		</DialogFrom>

		<DialogFrom width="890px" title="配送备注" :dialogVisible="dialogVisibleEnabled" @cancel="cancelEnabled"
			@dialogOK="dialogOKEnabled">
			<div style="margin-left: -20px;">
				<el-input type="textarea" :rows="2" placeholder="请输入配送备注" v-model="EnabledText">
				</el-input>
			</div>
		</DialogFrom>

		<DialogFrom width="890px" title="渠道备注" :dialogVisible="dialogVisibleChannelRemark" @cancel="cancelChannelRemark"
			@dialogOK="dialogOKChannelRemark">
			<div style="margin-left: -20px;">
				<el-input type="textarea" :rows="2" placeholder="请输入渠道备注" v-model="ChannelRemarkText">
				</el-input>
			</div>
		</DialogFrom>

		<DialogFrom width="890px" title="审批流程" :dialogVisible="dialogVisibleApprovalprocess"
			@cancel="cancelApprovalprocess" @dialogOK="dialogOKApprovalprocess">

			<div class="from">
				<Commontable width="1000px" colnum=7 :loadingTable="loadingTableprocess"
					:tableData="ApprovalprocessTableData" :headerData="ApprovalprocessheaderData" height="100%">
				</Commontable>
			</div>
		</DialogFrom>
		<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibleSubmit" @cancel="cancelSubmit"
			@dialogOK="dialogOKSubmit" :src="require('@/assets/icon/icon-errors.png')">
			<span
				style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要提交该数据吗？</span>
		</Dialog>
		<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisiblewithdraw" @cancel="cancelwithdraw"
			@dialogOK="dialogOKwithdraw" :src="require('@/assets/icon/icon-errors.png')">
			<span
				style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要撤回该数据吗？</span>
		</Dialog>
		<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibleApproved" @cancel="cancelApproved"
			@dialogOK="dialogOKApproved" :src="require('@/assets/icon/icon-errors.png')">
			<span
				style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要审批通过该数据吗？</span>
		</Dialog>
		<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibleDel" @cancel="cancelDel" @dialogOK="dialogOKDel"
			:src="require('@/assets/icon/icon-del2.png')">
			<span
				style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要删除该数据吗？</span>
		</Dialog>
	</div>
</template>

<script>
	import FormUpload from '@/components/comm-fromUpload.vue'
	import FromComm from '../../../components/fromComponents/Commfrom/from-comm.vue'
	import CommonBtngroup from '../../../../../../components/commongroup.vue'
	import Commonbtn from '../../../../../../components/common-btn.vue'
	import CommonbtnUpLoad from '../../../../../../components/common-upload.vue'
	import Commontable from '../../../../../../components/common-table.vue'
	import Pagination from '../../../../../../components/pagination.vue'
	import DialogFrom from '../../../../../../components/dialog-from.vue'
	import Dialog from '../../../../../../components/dialog.vue'
	import FromArr from './FromData/FromArr'
	import headerData from './headerData/headerData'
	import headerDataEditor from './headerData/headerDataEditor'
	import headerDataEditorHP from './headerData/headerDataEditorHP'
	import ApprovalprocessheaderData from './headerData/ApprovalprocessheaderData'
	import FromArrEditor from './FromData/FromArrEditor'
	import utils from '../../../../../../common/utils'
	import PicturesType from './components/PicturesType.vue'
	import {
		BusinessAuthorityGeneratePdfList,
		BusinessAuthorityPrintPdfList,
		GetProductDetail,
		GetHelperDispatcherType,
		GetHelperProductType,
		HelperApprovalFlowStatus
	} from '@/api/channel'

	import {
		APPHospitalDispatcherList,
		APPHospitalDispatcherAdd,
		APPHospitalDispatcherInfo,
		APPHospitalDispatcherEdit,
		APPHospitalDispatcherDelete,
		APPHospitalDispatcherExport,
		APPHospitalDispatcherSubmit,
		APPHospitalDispatcherReject,
		APPHospitalDispatcherRejectDispatch,
		APPHospitalDispatcherApprove,
		APPHospitalDispatcherGetHostory,
		APPHospitalDispatcherRevoke,
		GetHelperLongApprovalFlowStatus,
		APPHospitalDispatcherEnabled,
		ImportAPPHospitalDispatcher,
		DownloadTempletDispatcher,
		UploadAPPHospImage,
		APPHospitalDispatcherChannelRemark
	} from '@/api/newsapi'

	import {
		HospitalList,
		GetHospitalType,
		InventoryClassList,
		ProductList,
		NeedUploadDocumentation,
		UpLoadAttachmentAuthority,
		GetProvince,
		GetCity
	} from '@/api/home'
	export default {
		components: {
			FormUpload,
			FromComm,
			CommonBtngroup,
			Commonbtn,
			Commontable,
			Pagination,
			DialogFrom,
			CommonbtnUpLoad,
			Dialog,
			PicturesType
		},
		props: {},
		data() {
			return {
				hdmInfo: null,
				NeedUpload: false,
				dialogVisibAuthorizationsAdd: false,
				dialogVisiblesdrjg: false,
				dialogVisibleSubmit: false,
				dialogVisibleReject: false,
				dialogVisibleEnabled: false,
				dialogVisibleChannelRemark: false,
				dialogVisibleApproved: false,
				dialogVisibleApprovalprocess: false,
				dialogVisiblewithdraw: false,
				GCTQORGCYL: false,
				dialogVisibleDel: false,
				AppEditorFalg: false, //控制新增数据提交状态(空 false 否则 true)
				loadingTableEditor: false,
				loadingTableHP: false,
				loadingTableprocess: false,
				InvClass: '',
				invClassRow: '',
				title: '',
				TitleEditor: '',
				ProviderID: '',
				ProviderName: '',
				CusCode: '',
				CusName: '',
				EnabledText: '',
				ChannelRemarkText: '',
				RejectText: '',
				HDMID: null,
				HDMIDs: [],
				PageIndex: 1,
				pageSize: 10,
				total: 0,
				totalHP: 0,
				pageSizeHP: 10,
				pageIndexHP: 1,
				tableDataBottom: [],
				headerDataEditor: [],
				tableDataEditor: [], //医院选中数据进行过滤后的数据
				TableDataEditorDataOK: [], //医院选中数据
				EditorTabelData: [], //编辑配送申请弹窗表格选中数据
				tableDatadrjg: [],
				DataListOK: [],
				FromArr: [],
				FromArrEditor: [],
				headerData: [],
				tableData: [],
				tableDataEditorHP: [],
				headerDataEditorHP: [],
				ApprovalprocessheaderData: [],
				ApprovalprocessTableData: [],
				dialogVisibleRejectType: '',
				from: {
					ProviderName: '',
					CusName: '',
					AuthorityCode: '',
					InvClass: '',
					ProvinceID: '',
					Status: '',
					CreateTime1: '',
					CreateTime2: '',
					MyApproval: '',
					HPName: '',
					ApplyCode: '',
					ID: '',
					MyApproval: '',
				},
				fromHP: {
					hpCode: "",
					hpName: "",
					HosType: "",
					CreateTime1: "",
					CreateTime2: "",
					authorizeStatus: "",
					aProvinceID: "",
					aCityID: "",
					aDistrictID: "",
				},
				qx: {
					add: false,
					update: false,
					del: false,
					stopif: true,
					daoc: true,
					assignment: false,
					enabled: false,
					submit: false,
					skip: false, //跳过
					reset: false, //重置
					revoke: false, //弃审
					changeth: false, //弃审
					approval: false, //驳回OR审批通过
					download: false,
				},
				chackbox: true,
				fileList: [],
			}
		},
		computed: {
			userInfo() {
				return this.$store.state.MenusData;
			}
		},
		created() {
			this.getData()
			this.inventoryClassList()
			this.getHelperDispatcherType();
			this.getHelperProductType();
			this.HelperApprovalFlowStatus();
			this.ProductList();
		},
		mounted() {
			this.FromArr = JSON.parse(JSON.stringify(FromArr))
			this.FromArrEditor = JSON.parse(JSON.stringify(FromArrEditor))
			this.headerData = JSON.parse(JSON.stringify(headerData))
			this.headerDataEditor = JSON.parse(JSON.stringify(headerDataEditor))
			this.headerDataEditorHP = JSON.parse(JSON.stringify(headerDataEditorHP))
			this.ApprovalprocessheaderData = JSON.parse(JSON.stringify(ApprovalprocessheaderData))
			this.QX()
			this.getProvinceList();
		},
		methods: {
			getSingleSelectedRow(actionName) {
				if (this.DataListOK.length !== 1) {
					this.$message.warning(`请勾选一条数据进行${actionName}`);
					return null;
				}
				return this.DataListOK[0];
			},
                        getProductTypePayload(value = this.FromArrEditor[0].modelvalue) {
                                if (Array.isArray(value)) {
                                        return value.filter(item => item !== '' && item !== null && item !== undefined);
                                }
                                return value === '' || value === null || value === undefined ? [] : [value];
                        },
                        getProductTypeValue(value) {
                                if (Array.isArray(value)) {
                                        return value.length ? value[0] : '';
                                }
                                return value === null || value === undefined ? '' : value;
                        },
			//上传
			async UploadFiles(e) {
				const loading = this.$loading({
					lock: true,
					text: '加载中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let formData = new FormData();
				formData.append('files', e);
				let {
					code,
					data,
					message
				} = await UploadAPPHospImage(formData);
				loading.close();
				if (code == 0) {
					this.fileList = this.fileList.concat(data);
				} else {
					this.$message.warning(message);
				}
			},
			// 编辑弹窗表单选择变化处理
			handleEditorSelectChange(index) {
				if (index === 2) {
					this.handleProvinceChange(this.FromArrEditor[2].modelvalue);
				}
			},
			//预览文件
			handViewFile(e) {
				window.open(e.FileUrl);
			},
			//删除文件
			handDelFile(i) {
				this.fileList.splice(i, 1);
			},
			// 列表
			async getData() {
				const loading = this.$loading({
					lock: true,
					text: '加载中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let {
					code,
					message,
					data
				} = await APPHospitalDispatcherList({
					InvClass: this.from.InvClass,
					ProvinceID: this.from.ProvinceID,
					HPName: this.from.HPName,
					DispatcherType: this.from.DispatcherType,
					Dispatcher: this.from.Dispatcher,
					Status: this.from.Status,
					CreateTime1: this.from.CreateTime1,
					CreateTime2: this.from.CreateTime2,
					MyApproval: this.from.MyApproval,
					pageIndex: this.PageIndex,
					pageSize: this.pageSize,
				})
				loading.close()
				if (code == 0) {
					this.total = data.Count
					this.tableData = data.data.map((item, index) => {
						item.ID = index;
						item.color = item.Status >= 50 ? 'green' : item.Status == 15 ? 'red' : '';
						//console.log(item.color, item.Status)
						return item;
					})
				} else {
					this.$message.warning(message)
				}
			},
			// 产品线下拉
			async inventoryClassList() {
				let {
					code,
					data
				} = await InventoryClassList({

				})
				if (code == 0) {
					this.FromArr[0].options = []
					data.data.map((item, index) => {
						let obj = {
							key: item.InvClass,
							value: item.InvClassName
						}
						this.FromArr[0].options.push(obj)
					})
				}
			},
			// 查询配送商类型
			async getHelperDispatcherType() {
				let {
					data,
					code,
					message
				} = await GetHelperDispatcherType({})
				if (code == 0) {
					this.FromArr[2].options = []
					this.FromArrEditor[6].options = []
					data.map((item, index) => {
						let obj = {
							key: String(item.Value),
							value: item.Text
						}
						this.FromArr[2].options.push(obj)
						this.FromArrEditor[6].options.push(obj)
					})
				} else {
					this.$message.error(message);
				}
			},
			// 查询产品类型
			async getHelperProductType() {
				let {
					data,
					code,
					message
				} = await GetHelperProductType({})
				if (code == 0) {
					this.FromArrEditor[0].options = []
					data.map((item, index) => {
						let obj = {
							key: Number(item.Value),
							value: item.Text
						}
						this.FromArrEditor[0].options.push(obj)
					})
				} else {
					this.$message.error(message);
				}
			},
			// 产品下拉数据
			async ProductList() {
				let {
					code,
					message,
					data
				} = await ProductList({})
				if (code == 0) {
					this.FromArrEditor[1].options = []
					data.data.map((item, index) => {
						let obj = {
							key: item.PDCode,
							value: item.ShowNameForCombo
						}
						this.FromArrEditor[1].options.push(obj)
					})
				}
			},
			// 省份下拉数据
			async getProvinceList() {
				let {
					code,
					data,
					message
				} = await GetProvince({})
				if (code == 0) {
					this.FromArr[1].options = [];
					this.FromArrEditor[2].options = [];
					data.map((item, index) => {
						let obj = {
							key: item.Value,
							value: item.Text
						}
						this.FromArr[1].options.push(obj);
						this.FromArrEditor[2].options.push(obj);
					})
				}
			},
			// 省份变化时获取城市列表
			async handleProvinceChange(provinceId) {
				this.FromArrEditor[3].modelvalue = '';
				this.FromArrEditor[3].options = [];
				if (!provinceId) {
					return;
				}
				let {
					code,
					data,
					message
				} = await GetCity({
					params: {
						ProvinceID: provinceId
					}
				})
				if (code == 0) {
					data.map((item, index) => {
						let obj = {
							key: item.Value,
							value: item.Text
						};
						this.FromArrEditor[3].options.push(obj);
					});
				}
			},

			// 审批流状态下拉
			async HelperApprovalFlowStatus() {
				let {
					code,
					data,
					message
				} = await GetHelperLongApprovalFlowStatus({})
				if (code == 0) {
					this.FromArr[4].options = []
					data.map((item, index) => {
						let obj = {
							key: item.Value,
							value: item.Text
						}
						this.FromArr[4].options.push(obj)
					})
				} else {
					this.$message.warning(message)
				}
			},
			// 导出
			async APPHospitalDispatcherExport() {
				const loading = this.$loading({
					lock: true,
					text: '正在导出...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let resexprot = await APPHospitalDispatcherExport({
					InvClass: this.from.InvClass,
					HPName: this.from.HPName,
					DispatcherType: this.from.DispatcherType,
					Dispatcher: this.from.Dispatcher,
					Status: this.from.Status,
					CreateTime1: this.from.CreateTime1,
					CreateTime2: this.from.CreateTime2,
					MyApproval: this.from.MyApproval,
				})
				loading.close()
				if (resexprot) {
					let date = new Date()
					let str = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}-${date.getTime()}`
					utils.downloadFile(resexprot, `配送申请导出${str}`, "xlsx")
				} else {
					// 返回json
					this.$message.warning('导出失败');
				}
			},
			// 导出事件调用接口
			AppExport() {
				this.APPHospitalDispatcherExport()
			},
			// 新增
			async APPHospitalDispatcherAdd() {
				const loading = this.$loading({
					lock: true,
					text: '加载中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let {
					code,
					message,
					data
				} = await APPHospitalDispatcherAdd({
					OrgHDMID: this.HDMID,
                                        ListProductType: this.getProductTypePayload(),
					ListPDCode: this.FromArrEditor[1].modelvalue,
					ProvinceID: this.FromArrEditor[2].modelvalue,
					ListCityID: this.FromArrEditor[3].modelvalue,
					ListHospitalID: this.FromArrEditor[4].modelvalue,
					TechnicalOffices: this.FromArrEditor[5].modelvalue,
					DispatcherType: this.FromArrEditor[6].modelvalue,
					Dispatcher: this.FromArrEditor[7].modelvalue,
					Remark: this.FromArrEditor[8].modelvalue,
					AttachmentNames: this.fileList.map(it => it.FileName),
				});
				loading.close()
				this.$message.success(message);
				if (code == 0) {
					this.dialogVisibAuthorizationsAdd = false;
					this.FromArrEditor.map(it => {
						it.modelvalue = '';
						return it;
					})
					this.HDMID = null;
					this.hdmInfo = null;
					this.getData()
					setTimeout(() => {
						this.fileList = [];
					}, 200)
				}
			},
			// 修改配送申请
			async APPHospitalDispatcherEdit() {
				const loading = this.$loading({
					lock: true,
					text: '加载中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let {
					code,
					message,
					data
				} = await APPHospitalDispatcherEdit({
					HDMID: this.HDMID,
                                        ListProductType: this.getProductTypePayload(),
					ListPDCode: this.FromArrEditor[1].modelvalue,
					ProvinceID: this.FromArrEditor[2].modelvalue,
					ListCityID: this.FromArrEditor[3].modelvalue,
					ListHospitalID: this.FromArrEditor[4].modelvalue,
					TechnicalOffices: this.FromArrEditor[5].modelvalue,
					DispatcherType: this.FromArrEditor[6].modelvalue,
					Dispatcher: this.FromArrEditor[7].modelvalue,
					Remark: this.FromArrEditor[8].modelvalue,
					AttachmentNames: this.fileList.map(it => it.FileName),
				});
				loading.close()
				this.$message.success(message);
				if (code == 0) {
					this.dialogVisibAuthorizationsAdd = false;
					this.FromArrEditor.map(it => {
						it.modelvalue = '';
						return it;
					})
					this.HDMID = null;
					this.hdmInfo = null;
					this.getData();
					setTimeout(() => {
						this.fileList = [];
					}, 200)
				}
			},
			// 详情
			async APPHospitalDispatcherInfo() {
				const loading = this.$loading({
					lock: true,
					text: '加载中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let {
					code,
					data,
					message
				} = await APPHospitalDispatcherInfo({
					HDMID: this.HDMID
				})
				loading.close()
				if (code == 0) {
					this.FromArrEditor[4].options = [];
					this.FromArrEditor[0].modelvalue = this.getProductTypeValue(data.data.ListProductType);
					let pdCode = data.data.ListPDCode;
					if (Array.isArray(pdCode)) {
						this.FromArrEditor[1].modelvalue = pdCode;
					} else if (typeof pdCode === 'string' && pdCode) {
						this.FromArrEditor[1].modelvalue = pdCode.includes(',') ? pdCode.split(',') : [pdCode];
					} else if (pdCode !== null && pdCode !== undefined && pdCode !== '') {
						this.FromArrEditor[1].modelvalue = [pdCode];
					} else {
						this.FromArrEditor[1].modelvalue = [];
					}
					let listHospitalId = data.data.ListHospitalID;
					let listHospitalName = data.data.ListHospitalName;
					if (listHospitalId !== null && listHospitalId !== undefined && !Array.isArray(listHospitalId)) {
						listHospitalId = typeof listHospitalId === 'string' && listHospitalId.includes(',') ? listHospitalId.split(',') : [listHospitalId];
					}
					if (listHospitalName !== null && listHospitalName !== undefined && !Array.isArray(listHospitalName)) {
						listHospitalName = typeof listHospitalName === 'string' && listHospitalName.includes(',') ? listHospitalName.split(',') : [listHospitalName];
					}
					this.FromArrEditor[4].modelvalue = listHospitalId || [];
					listHospitalName && listHospitalName.forEach((it, ix) => {
						this.FromArrEditor[4].options.push({
							value: listHospitalId && listHospitalId[ix] ? listHospitalId[ix] : '',
							label: it
						})
					})
					const provinceId = data.data.ProvinceID == null || data.data.ProvinceID === '' ? '' : String(data.data.ProvinceID);
					this.FromArrEditor[2].modelvalue = provinceId;
					this.handleProvinceChange(provinceId).then(() => {
						let listCityId = data.data.ListCityID;
						if (listCityId !== null && listCityId !== undefined) {
							if (!Array.isArray(listCityId)) {
								listCityId = typeof listCityId === 'string' && listCityId.includes(',') ? listCityId.split(',') : [listCityId];
							}
							if (listCityId.length) {
								this.FromArrEditor[3].modelvalue = listCityId.map(it=>it+'');
							}
						}
					});
					this.FromArrEditor[5].modelvalue = data.data.TechnicalOffices;
					this.FromArrEditor[6].modelvalue = String(data.data.DispatcherType);
					this.FromArrEditor[7].modelvalue = data.data.Dispatcher;
					this.FromArrEditor[8].modelvalue = data.data.Remark;
					this.FromArrEditor.map((it, ix) => {
						it.disabled = this.TitleEditor == '查看配送申请' && ix != 1 && ix != 4 ? true : false;
						return it;
					})

					if (data.data.AttachmentNames) {
						this.fileList = data.data.AttachmentNames.map(it => {
							it.FileName = it.ImagePath;
							it.FileNameOrg = it.ImagePath;
							it.FileUrl = it.ImageUrlPath;
							return it;
						});
					}
					this.dialogVisibAuthorizationsAdd = true
				} else {
					this.$message.error("请选择操作的数据！")
				}
			},
			// 删除配送申请
			async APPHospitalDispatcherDelete() {
				let HDMIDs = []
				this.DataListOK.forEach((item, index) => {
					HDMIDs.push(item.HDMID);
				})
				let {
					code,
					message,
					data
				} = await APPHospitalDispatcherDelete({
					HDMIDs: HDMIDs,
				})
				this.dialogVisibleDel = false;
				this.$refs.refTableCenter.$refs.fileTable.clearSelection()
				if (code == 0) {
					this.$message.success(message)
					this.getData()
				} else {
					if (data.length) {
						this.$alert(`${data.join('<br/>')}`, '提示', {
							dangerouslyUseHTMLString: true,
							showConfirmButton: false
						}).then(() => {}).catch(() => {});
					} else {
						this.$message({
							type: 'error',
							message: message
						});
					}
				}
			},
			// AutoComplete事件
			async remoteMethod(val) {
				this.FromArrEditor[4].loading = true;
				let {
					code,
					message,
					data
				} = await HospitalList({
					hpName: val.qurey,
					HosType: '医院',
					IncludeCity: '1'
				})
				this.FromArrEditor[4].loading = false
				if (code == 0) {
					this.FromArrEditor[4].options = []
					data.data.map((item, index) => {
						let obj = {
							value: item.HPID,
							label: item.HPName,
						}
						this.FromArrEditor[4].options.push(obj)
					})
				} else {
					this.$message.warning(message)
				}
			},
			add() {
				this.TitleEditor = '新增配送申请'
				this.dialogVisibAuthorizationsAdd = true;
				this.FromArrEditor.map(it => {
					it.disabled = false;
					it.modelvalue = '';
					return it;
				})
			},
			update(e) {
				const row = this.getSingleSelectedRow(e === 'look' ? '查看' : e === 'change' ? '变更' : '修改');
				if (!row) return;
				this.hdmInfo = row;
				this.HDMID = row.HDMID;
				if (this.hdmInfo.Status < 30 && e === 'change') {
					this.$message.error('当前状态不可变更');
					return;
				}
				this.TitleEditor = e === 'edit' ? '修改配送申请' : e === 'change' ? '变更配送申请' : '查看配送申请';
				this.APPHospitalDispatcherInfo()
			},
			del() {
				if (this.DataListOK.length == 0) {
					this.$message.error("请选择需要删除的数据！(多选)")
					return
				}
				this.dialogVisibleDel = true
			},
			// 提交
			async APPHospitalDispatcherSubmit() {
				const loading = this.$loading({
					lock: true,
					text: '提交中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let HDMIDs = []
				this.DataListOK.forEach((item, index) => {
					HDMIDs.push(item.HDMID);
				})
				let {
					code,
					data,
					message
				} = await APPHospitalDispatcherSubmit({
					HDMIDs: HDMIDs
				})
				if (code == 0) {
					this.dialogVisibleSubmit = false
					this.$message.success(message)
					this.getData()
					this.$refs.refTableCenter.$refs.fileTable.clearSelection()
				} else if (code == 1) {
					this.dialogVisibleSubmit = false
					this.title = "提交结果"
					this.dialogVisiblesdrjg = true
					this.tableDatadrjg = data
				} else {
					this.$message.warning(message)
				}
				loading.close()
			},

			SubmitApply() {
				if (this.DataListOK.length == 0) {
					this.$message.error("请选择需要提交的数据！(多选)")
					return
				}
				this.dialogVisibleSubmit = true
			},
			cancelSubmit() {
				this.dialogVisibleSubmit = false
			},
			dialogOKSubmit() {
				this.DataListOK.forEach((item, index) => {
					this.HDMIDs.push(item.HDMID);
				})
				this.APPHospitalDispatcherSubmit()
			},
			// 撤回
			async APPHospitalDispatcherRevoke(val) {
				const loading = this.$loading({
					lock: true,
					text: '撤回中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let HDMIDs = []
				this.DataListOK.forEach((item, index) => {
					HDMIDs.push(item.HDMID);
				})
				let {
					code,
					data,
					message
				} = await APPHospitalDispatcherRevoke({
					HDMIDs: HDMIDs,
					Reason: val
				})
				if (code == 0) {
					this.dialogVisiblewithdraw = false
					this.$message.success(message)
					this.getData()
					this.$refs.refTableCenter.$refs.fileTable.clearSelection()
				} else if (code == 1) {
					this.dialogVisiblewithdraw = false
					this.title = "撤回结果"
					this.dialogVisiblesdrjg = true
					this.tableDatadrjg = data
				} else {
					this.$message.warning(message)
				}
				loading.close()
			},
			Withdraw() {
				if (this.DataListOK.length == 0) {
					this.$message.error("请选择需要撤回的数据！(多选)")
					return
				}
				let isPromt = this.DataListOK.filter(item => item.Approver);
				if (isPromt.length) {
					this.$prompt('请输入撤回原因', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
					}).then(({
						value
					}) => {
						this.APPHospitalDispatcherRevoke(value);
					}).catch(() => {});
				} else {
					this.dialogVisiblewithdraw = true
				}
			},
			cancelwithdraw() {
				this.dialogVisiblewithdraw = false
			},
			dialogOKwithdraw() {
				this.APPHospitalDispatcherRevoke()

			},
			// 审批通过
			async APPHospitalDispatcherApprove() {
				const loading = this.$loading({
					lock: true,
					text: '审批中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let HDMIDs = []
				this.DataListOK.forEach((item, index) => {
					HDMIDs.push(item.HDMID);
				})
				let {
					code,
					data,
					message
				} = await APPHospitalDispatcherApprove({
					HDMIDs: HDMIDs,
				})
				if (code == 0) {
					this.dialogVisibleApproved = false
					this.$message.success(message)
					this.getData()
					this.$refs.refTableCenter.$refs.fileTable.clearSelection()
				} else if (code == 1) {
					this.dialogVisibleApproved = false
					this.title = "审批通过结果"
					this.dialogVisiblesdrjg = true
					this.tableDatadrjg = data
				} else {
					this.$message.warning(message)
				}
				loading.close()
			},
			Approved() {
				if (this.DataListOK.length == 0) {
					this.$message.error("请选择需要审核通过的数据！(多选)")
					return
				}
				this.dialogVisibleApproved = true

			},
			cancelApproved() {
				this.dialogVisibleApproved = false
			},
			dialogOKApproved() {
				this.DataListOK.forEach((item, index) => {
					this.HDMIDs.push(item.HDMID);
				})
				this.APPHospitalDispatcherApprove()
			},
			//启用配送
			Enabledapproval() {
				if (this.DataListOK.length == 0) {
					this.$message.error("请选择需要启用配送的数据！(多选)")
					return
				}
				this.dialogVisibleEnabled = true
			},
			cancelEnabled() {
				this.EnabledText = '';
				this.dialogVisibleEnabled = false
			},
			dialogOKEnabled() {
				this.DataListOK.forEach((item, index) => {
					this.HDMIDs.push(item.HDMID);
				})
				this.APPHospitalDispatcherEnabled()
			},
			ChannelRemark() {
				if (this.DataListOK.length == 0) {
					this.$message.warning('请先勾选数据')
					return
				}
				this.dialogVisibleChannelRemark = true
			},
			cancelChannelRemark() {
				this.ChannelRemarkText = '';
				this.dialogVisibleChannelRemark = false
			},
			dialogOKChannelRemark() {
				this.HDMIDs = []
				this.DataListOK.forEach((item, index) => {
					this.HDMIDs.push(item.HDMID);
				})
				this.APPHospitalDispatcherChannelRemark()
			},
			async APPHospitalDispatcherChannelRemark() {
				const loading = this.$loading({
					lock: true,
					text: '设置渠道备注中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let {
					code,
					data,
					message
				} = await APPHospitalDispatcherChannelRemark({
					hdmiDs: this.HDMIDs,
					channelRemark: this.ChannelRemarkText
				})
				loading.close()
				if (code == 0) {
					this.$message.success('设置渠道备注成功')
					this.cancelChannelRemark()
					this.DataListOK = []
					this.HDMIDs = []
					this.GetDataList()
				} else {
					this.$message.error(message || '设置渠道备注失败')
				}
			},
			// 启用配送
			async APPHospitalDispatcherEnabled() {
				const loading = this.$loading({
					lock: true,
					text: '驳回中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let HDMIDs = []
				this.DataListOK.forEach((item, index) => {
					HDMIDs.push(item.HDMID);
				})
				let {
					code,
					data,
					message
				} = await APPHospitalDispatcherEnabled({
					HDMIDs: HDMIDs,
					DispatchRemark: this.EnabledText
				})
				if (code == 0) {
					this.dialogVisibleEnabled = false
					this.$message.success(message)
					this.getData()
					this.$refs.refTableCenter.$refs.fileTable.clearSelection()
				} else if (code == 1) {
					this.dialogVisibleReject = false
					this.title = "启用配送结果"
					this.dialogVisiblesdrjg = true
					this.tableDatadrjg = data
				} else {
					this.$message.warning(message)
				}
				loading.close()
			},
			// 驳回
			async APPHospitalDispatcherReject() {
				const loading = this.$loading({
					lock: true,
					text: '驳回中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let HDMIDs = []
				this.DataListOK.forEach((item, index) => {
					HDMIDs.push(item.HDMID);
				})
				let {
					code,
					data,
					message
				} = await APPHospitalDispatcherReject({
					HDMIDs: HDMIDs,
					Reason: this.RejectText
				})
				if (code == 0) {
					this.dialogVisibleReject = false
					this.$message.success(message)
					this.getData()
					this.$refs.refTableCenter.$refs.fileTable.clearSelection()
				} else if (code == 1) {
					this.dialogVisibleReject = false
					this.title = "驳回结果"
					this.dialogVisiblesdrjg = true
					this.tableDatadrjg = data
				} else {
					this.$message.warning(message)
				}
				loading.close()
			},
			async APPHospitalDispatcherRejectDispatch() {
				const loading = this.$loading({
					lock: true,
					text: '驳回中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let HDMIDs = []
				this.DataListOK.forEach((item, index) => {
					HDMIDs.push(item.HDMID);
				})
				let {
					code,
					data,
					message
				} = await APPHospitalDispatcherRejectDispatch({
					HDMIDs: HDMIDs,
					Reason: this.RejectText
				})
				if (code == 0) {
					this.dialogVisibleReject = false;
					this.dialogVisibleRejectType = '';
					this.$message.success(message)
					this.getData()
					this.$refs.refTableCenter.$refs.fileTable.clearSelection()
				} else if (code == 1) {
					this.dialogVisibleReject = false
					this.dialogVisibleRejectType = '';
					this.title = "驳回结果"
					this.dialogVisiblesdrjg = true
					this.tableDatadrjg = data
				} else {
					this.$message.warning(message)
				}
				loading.close()
			},
			Rejectapproval(t = '') {
				if (this.DataListOK.length == 0) {
					this.$message.error("请选择需要驳回的数据！(多选)")
					return
				}
				this.dialogVisibleReject = true
				this.dialogVisibleRejectType = t;
			},
			cancelReject() {
				this.dialogVisibleReject = false;
				this.dialogVisibleRejectType = '';
			},
			dialogOKReject() {
				this.DataListOK.forEach((item, index) => {
					this.HDMIDs.push(item.HDMID);
				})
				if (this.dialogVisibleRejectType) {
					this.APPHospitalDispatcherRejectDispatch()
				} else {
					this.APPHospitalDispatcherReject()
				}
			},
			// 审批流程
			async APPHospitalDispatcherGetHostory() {
				this.loadingTableprocess = true
				let {
					code,
					data,
					message
				} = await APPHospitalDispatcherGetHostory({
					HDMID: this.HDMID,
				})
				if (code == 0) {
					this.dialogVisibleApprovalprocess = true;
					this.ApprovalprocessTableData = data;
				} else {
					this.$message.warning(message)
				}
				this.loadingTableprocess = false
			},
			Approvalprocess() {
				const row = this.getSingleSelectedRow('查看审批流程');
				if (!row) return;
				this.HDMID = row.HDMID;
				this.APPHospitalDispatcherGetHostory()
			},
			cancelApprovalprocess() {
				this.dialogVisibleApprovalprocess = false
			},
			dialogOKApprovalprocess() {
				this.dialogVisibleApprovalprocess = false
			},
			addClickRow() {
				this.HospitalList('DialogFromList', "", "医院")
				this.GetHospitalType()
			},

			canceldrjg() {
				this.dialogVisiblesdrjg = false
			},
			dialogOKdrjg() {
				this.dialogVisiblesdrjg = false
			},
			// 删除取消
			cancelDel() {
				this.dialogVisibleDel = false
			},
			// 确认删除
			dialogOKDel() {
				this.DataListOK.forEach((item, index) => {
					this.HDMIDs.push(item.HDMID);
				})
				this.APPHospitalDispatcherDelete()
			},
			select() {
				this.pageIndex = 1
				this.from.InvClass = this.FromArr[0].modelvalue ? this.FromArr[0].modelvalue.join(',') : '';
				this.from.ProvinceID = this.FromArr[1].modelvalue;
				this.from.HPName = this.FromArr[2].modelvalue;
				this.from.DispatcherType = this.FromArr[3].modelvalue;
				this.from.Dispatcher = this.FromArr[4].modelvalue;
				this.from.Status = this.FromArr[5].modelvalue;
				this.from.CreateTime1 = this.FromArr[6].StartTime;
				this.from.CreateTime2 = this.FromArr[6].EndTime;
				this.from.MyApproval = this.$refs.btngroup.checkeds == true ? 1 : ""
				this.getData()
			},
			reset() {
				this.FromArr.map((item, index) => {
					if (index == 6) {
						item.StartTime = '';
						item.EndTime = '';
					}
					item.modelvalue = ''
				})
				this.$refs.btngroup.checkeds = false;
			},
			handleSelectionChangeEditor(val) {
				this.EditorTabelData = val
			},
			handleSelectionChangeEditorHP(val) {
				this.TableDataEditorDataOK = val
			},
			onRowClick(val) {
				this.hdmInfo = val;
				this.HDMID = val.HDMID;
			},
			onRowClickHP() {

			},
			onRowClickEditor() {

			},
			handleCurrentChange(PageIndex) {
				this.PageIndex = PageIndex
				this.$refs.refTableCenter.$refs.fileTable.clearSelection()
				this.getData()
			},
			handleSizeChange(PageSize) {
				this.pageSize = PageSize
				this.$refs.refTableCenter.$refs.fileTable.clearSelection()
				this.getData()
			},
			handleCurrentChangeHP(PageIndex) {
				this.pageIndexHP = PageIndex
				this.HospitalList('DialogFromList', "", "医院")
			},
			handleSizeChangeHP(PageSize) {
				this.pageSizeHP = PageSize
				this.HospitalList('DialogFromList', "", "医院")
			},
			cancelAuthorizationsAdd() {
				this.dialogVisibAuthorizationsAdd = false;
				setTimeout(() => {
					this.fileList = [];
				}, 200)
			},
			dialogOKAuthorizationsAdd() {
				if (this.TitleEditor == '修改配送申请') {
					this.APPHospitalDispatcherEdit()
				}
				if (this.TitleEditor == '新增配送申请' || this.TitleEditor == '变更配送申请') {
					this.APPHospitalDispatcherAdd()
				}
			},
			// 导入
			async customerImport(file) {
				if (file) {
					const loading = this.$loading({
						lock: true,
						text: "上传中...",
						spinner: "el-icon-loading",
						background: "rgba(255,255,255,0.3)",
					});
					let formData = new FormData();
					formData.append("file", file);
					let res = await ImportAPPHospitalDispatcher(formData);
					if (res.code == 0) {
						this.$message({
							type: "success",
							message: res.message,
						});
						loading.close();
					} else if (res.code == 101) {
						this.$message({
							type: "warning",
							message: res.message,
						});
						loading.close();
					} else {
						this.dialogVisiblesdrjg = true;
						this.tableDatadrjg = res.data;
						this.title = "导入结果";
						this.$message({
							type: "error",
							message: res.message,
						});
						loading.close();
					}
					loading.close();
				}
			},
			// 导入
			seImport(file) {
				this.customerImport(file);
			},
			// 下载导入模板
			async customerDownloadTemplet() {
				// 测试
				// this.downURL = "https://bs.oudot.cn/Download/入库单导入模板(一级经销商).xlsx"
				let {
					data,
					code,
					message
				} = await DownloadTempletDispatcher({});
				if (code == 0) {
					window.location.href = data;
				} else if (code == 101) {
					this.$message({
						type: "warning",
						message: message,
					});
				} else {
					this.$message({
						type: "error",
						message: message,
					});
				}
			},
			SeconDowload() {
				this.customerDownloadTemplet();
			},
			QX() {
				let qus = []
				let data = JSON.parse(localStorage.getItem("MenusData"))
				data.CusWebMenus.map((item, index) => {
					if (item.NodeID == 77) {
						item.Nodes.map((items, indexs) => {
							if (items.NodeID == 1076) {
								items.Nodes.map((itemes, indexes) => {
									if (itemes.NodeID == 1077) {
										qus = itemes.Buttons
									}
								})
							}
						})
					}
				})
				console.log(this.qus, "this.qus");
				if (qus && qus.length) {
					qus.map((item, index) => {
						if (item.NodeName == 'add') {
							this.qx.add = true
						} else if (item.NodeName == 'edit') {
							this.qx.update = true
						} else if (item.NodeName == 'delete') {
							this.qx.del = true
						} else if (item.NodeName == 'stopif') {
							this.qx.del = true
						} else if (item.NodeName == 'assignment') {
							this.qx.assignment = true
						} else if (item.NodeName == 'enabled') {
							this.qx.enabled = true
						} else if (item.NodeName == 'skip') {
							this.qx.skip = true
						} else if (item.NodeName == 'reset') {
							this.qx.reset = true
						} else if (item.NodeName == 'setting') {
							this.qx.setting = true
						} else if (item.NodeName == 'submit') {
							this.qx.submit = true
						} else if (item.NodeName == 'approval') {
							this.qx.approval = true
						} else if (item.NodeName == 'Download') {
							this.qx.download = true
						}
					})
				}
			},
		},
		// watch: {
		// 	dialogVisibAuthorizationsAdd: {
		// 		handler(newVal, OldVal) {
		// 			if (!newVal) {
		// 				this.FromArrEditor.forEach((item, index) => {
		// 					item.disabled = false
		// 					if (index == 3) {
		// 						item.options = []
		// 					}
		// 					if (index == 4) {
		// 						item.StartTime = ''
		// 						item.EndTime = ''
		// 					} else if (index == 5) {
		// 						item.checked = false
		// 					} else {
		// 						item.modelvalue = ''
		// 					}
		// 				})
		// 				this.$refs.refTableCenterApply.$refs.fileTable.clearSelection()
		// 				this.tableDataEditor = []
		// 				this.addClickRowOptional = false
		// 				this.AppEditorFalg = false

		// 			} else {
		// 				if (this.TitleEditor == '修改配送申请') {
		// 					this.FromArrEditor[0].disabled = true
		// 					this.FromArrEditor[1].disabled = true
		// 				}
		// 				if (this.TitleEditor == '新增配送申请') {
		// 					if (this.FromArrEditor[0].modelvalue == '' && this.FromArrEditor[1].modelvalue == '') {
		// 						this.FromArrEditor.forEach((item, index) => {
		// 							if (index != 0 && index != 1) {
		// 								item.disabled = true
		// 							}
		// 						})
		// 						this.AppEditorFalg = false
		// 					} else {
		// 						this.FromArrEditor.forEach((item, index) => {
		// 							if (index != 0 && index != 1) {
		// 								item.disabled = false
		// 							}
		// 						})
		// 						this.AppEditorFalg = true
		// 					}
		// 				}
		// 			}
		// 		},
		// 		deep: true,
		// 		immediate: false
		// 	},
		// },
	}
</script>
<style scoped lang="less">
	.GCTQ {
		// border: 1px solid red;
		transition: all 0.5s;
	}

	.GCYL {
		//  border: 1px solid rgb(23, 120, 211);
		transition: all 0.5s;
	}

	.Authority {
		width: 100%;
		height: 100%;

		.TopSearch {
			margin: 1px 10px;
			width: 938px;
			height: 180px;
			// border: 1px solid #e5e7ea;
			box-shadow: 0px 1px 4px 2px #e5e7ea;
			border-radius: 0px 0px 0px 0px;
			opacity: 1;
		}

		.BottomTable {
			margin: 32px 10px;
			padding: 10px;
			width: 920px;
			// height: 518px;
			// border: 1px solid #e5e7ea;
			box-shadow: 0px 1px 4px 2px #e5e7ea;
			border-radius: 0px 0px 0px 0px;
			opacity: 1;
		}

		.TableBottom {
			border: 1xp solid red;

			.TBlabel {
				margin-left: 10px;
				margin-top: 5px;
				margin-bottom: 5px;
				width: 100px;
				height: 32px;
				font-size: 14px;
				border: 1px solid rgb(230 230 230);
				line-height: 32px;
				text-align: center;
				cursor: pointer;
				display: inline-block;
				color: rgb(231 29 67);
				background-color: rgb(252 232 236);
			}
		}
	}

	.line {
		width: 960px;
		height: 1px;
		background: #e5e7ea;
		border-radius: 0px 0px 0px 0px;
		opacity: 1;
		margin-top: 20px;
	}

	/deep/.el-textarea .el-textarea__inner {
		width: 880px !important;
	}

	.fixed-model {
		width: 100%;
		height: 275px;
		position: absolute;
		top: 40px;
		left: 0px;
		bottom: 100px;
		background: transparent;
		z-index: 10;
	}


	.dialog-view {
		display: flex;

		.view-form {
			width: 450px;
		}

		.view-upload {
			width: 400px;

			.UploadData {
				display: inline-block;
				width: 100%;

				.lable {
					width: 130px;
					margin-top: 20px;
					font-weight: 500;
					font-size: 14px;
					color: rgb(51, 51, 51);
					height: 20px;
					display: inline-block;
				}

				.imgOrFile {
					width: 100%;
					display: flex;
					flex-wrap: wrap;
					justify-content: space-between;

					.file {
						line-height: 32px;
						border-radius: 2px;
						border: 1px solid rgb(230, 230, 230);
						display: inline-block;
						position: relative;
						//width: 300px;
						height: 32px;
						color: rgb(0, 0, 0);
						font-size: 12px;
						background-color: rgb(250, 251, 252);
						margin: 10px 7px 10px 0px;
						flex: 1;
						min-width: 344px;
						max-width: 344px;

						.fileName {
							width: 230px;
							display: inline-block;
							font-size: 14px;
							margin-left: 20px;
							overflow: hidden;
							text-overflow: ellipsis;
							white-space: nowrap;
						}

						.Del {
							display: inline-block;
							font-size: 14px;
							float: right;
							margin-right: 10px;
							color: rgb(231, 29, 67);
							cursor: pointer;
						}

						.See {
							//display: inline-block;
							font-size: 14px;
							float: right;
							margin-right: 10px;
							color: rgb(231, 29, 67);
							cursor: pointer;
						}
					}
				}
			}
		}
	}
</style>
